import { Download, Plus } from '@spcc/uikit'
import { PageHeader } from '@spcc/uikit'
import type { AddressbookHeaderProps } from '../types'

export function AddressbookHeader({
  title,
  subtitle,
  isRTL,
  onExport,
  onAdd,
  exportLabel,
  addLabel,
}: AddressbookHeaderProps) {
  return (
    <PageHeader
      title={title}
      subtitle={subtitle}
      isRTL={isRTL}
      actions={[
        {
          label: exportLabel,
          icon: Download,
          onClick: onExport,
          variant: 'outline',
        },
        {
          label: addLabel,
          icon: Plus,
          onClick: onAdd,
          primary: true,
        },
      ]}
    />
  )
}
